<template>
  <CoreDialog
    v-model="isVisible"
    size="md"
    data-qa="popup_map_departure_address_container"
    title="Откуда поедем?"
    divider
    @click:outside="handleCloseDepartureAddressPopup"
    @keydown.esc="handleCloseDepartureAddressPopup"
  >
    <v-text-field
      id="departureAddressInput"
      v-model="departureAddress.text"
      class="mb-n4"
      label="Адрес отправления"
      append-icon="ui-icon-geo-detect"
      height="40"
      color="text-secondary"
      :error-messages="errorMessage"
      outlined
      dense
      data-qa="popup_map_departure_address_text_input"
      @input="clearErrorMessagesAndDepartureCoords"
      @click:append="determinateCoords"
    />
    <template #actions>
      <v-btn
        text
        data-qa="popup_map_cancel_button"
        @click="handleCloseDepartureAddressPopup"
      >
        Отменить
      </v-btn>
      <v-btn
        color="primary"
        class="branding-btn branding-btn--primary"
        text
        data-qa="popup_map_plot_route_button"
        :disabled="Boolean(!departureAddress.text || errorMessage)"
        @click="handlePlotRouteButton"
      >
        Проложить маршрут
      </v-btn>
    </template>
  </CoreDialog>
</template>

<script>
import CoreDialog from 'src/core/CoreDialog/CoreDialog.vue'
import { PopupDepartureAddressLogic } from 'www/vue_components/common/PopupMap/mixins'

export default {
  name: 'PopupDepartureAddressDesktop',
  components: { CoreDialog },
  mixins: [PopupDepartureAddressLogic],
}
</script>
